class CarouselController {
  /* @ngInject */
  constructor(CarouselService, $element, $timeout) {
    this.carouselService = CarouselService;
    this.slides = $element[0].querySelector('.swiper-wrapper').children;
    this.$timeout = $timeout;
    this.hasWatch = $element[0].hasAttribute('carousel-watch');
  }

  $onChanges({carouselWatch}) {
    if (carouselWatch && carouselWatch.currentValue) {
      this.initCarousel();
    }
  }

  $postLink() {
    !this.hasWatch && this.initCarousel();
  }

  initCarousel() {
    this.$timeout(() => {
      Array.from(this.slides).forEach(el => el.classList.add('swiper-slide'));
      this.hasPagination = this.slides.length > 1;
    }).then(() => {
      return this.$timeout(() => this.carouselInstance = this.carouselService.create(this.carouselName, this.carouselSettings));
    }).then((carouselInstance) => {
      Object.keys(carouselInstance.bullets).forEach((key) => {
        carouselInstance.bullets[key].addEventListener && carouselInstance.bullets[key].addEventListener('click', () => {
          this.$timeout(() => carouselInstance.slideTo(key));
        });
      });
    });
  }

  $onDestroy() {
    this.carouselInstance && this.carouselInstance.destroy(true, true);
    this.carouselService.destroy(this.name);
  }
}

export default CarouselController;



// WEBPACK FOOTER //
// ./src/app/shared/carousel/carousel.controller.js